<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
                <CCardHeader class="p-1">
                  <CRow>
                    <CCol col="4" style="text-align: start ;padding:10px 20px 0 20px ">


                      <strong v-if="status_form_car==0">{{$t('addCar')}}</strong>
                      <strong v-else> {{$t('editCar')}}</strong>

                    </CCol>
                    <CCol col="4" style="text-align: center ;">

                      <strong v-if="status_form!=0">{{edit_name}}</strong>

                    </CCol>
                    <CCol col="4" style="text-align: end">


                      <CButton  @click="insert_machine_data()" class="mr-1 ml-1"  type="submit" size="sm"
                                color="secondary">
                        {{ $t('buttons.submit') }}
                      </CButton>

                      <CButton v-if="status_form_car!=0"
                          class="mr-1"
                          size="sm"
                          color="secondary"
                               @click="empty_list()"
                      >{{ $t("buttons.cancel") }}
                      </CButton>

                    </CCol>
                  </CRow>
                </CCardHeader>

                <CCardBody>

                  <CRow>
                    <CCol>
                      <CInput
                          :value.sync=car_title
                          :label="$t('components.name')"
                      />

                    </CCol>
                    <CCol>
                      <CSelect
                          :value.sync=car_type
                          :options="car_type_items"
                          :label="$t('components.vehicleType')"
                      />

                    </CCol>
                    <CCol>
                      <CSelect
                          :value.sync=car_name
                          :options="car_name_items"
                          :label="$t('vehicleModel')"
                      />

                    </CCol>
                    <CCol>

                      <CInput
                          :label="$t('components.licensePlate')"
                          v-model="car_pelak"
                      />
                    </CCol>
                    <CCol>

                      <CInput
                          :label="$t('components.maximumWeight')"
                          type="number"
                      v-on:keypress="isNumber($event)"
                          v-model="mizan_bar"
                      />
                    </CCol>
                    <CCol>

                      <CInput
                          :label="$t('weight')"
                          type="number"
                      v-on:keypress="isNumber($event)"
                          v-model="car_volume"

                      />
                    </CCol>
                  </CRow>


                </CCardBody>
                <CCard>
                  <CCardHeader>
                    <strong>{{$t('carList')}}</strong>
                  </CCardHeader>
                  <CCardBody>
                    <CDataTable
                        :items="car_items"
                        :fields="fields_machine"
                        @row-clicked="table_row_clicked"

                        :items-per-page="20"
                        hover
                        sorter
                        pagination
                    >
                      <template v-slot:[item_row_name]="{item}">

                          <td style="text-align: center">
                          <p >{{ item.row_id + 1 }}</p>

                        </td>

                      </template>

                      <template #vehicle="{item}">

                        <td>
                          <p >{{ item.carType }} {{ item.carTitle }}</p>

                        </td>

                      </template>

                      <template #weight="{item}">

                        <td>
                          <p >{{ item.weight }} {{ $t('components.weightUnit') }}</p>
                        </td>

                      </template>


                      <template #operation="{item}">
                        <td>

<!--                          <CButton-->
<!--                              color="warning"-->
<!--                              variant="outline"-->
<!--                              square-->
<!--                              class="mr-1"-->
<!--                              size="sm"-->
<!--                              @click="edit_item_car(item)"-->
<!--                          >-->
<!--                            <CIcon name="cil-pencil"/>-->
<!--                          </CButton>-->
                          <CButton

                              square
                              size="sm"
                              @click="delete_car_item_dialog(item)"
                          >
                            <CIcon size="sm" class="text-danger"  name="cil-trash"/>
                          </CButton>

                        </td>
                      </template>


                    </CDataTable>
                  </CCardBody>
                  <CCardFooter>

                  </CCardFooter>
                </CCard>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import BTabs from "../../tabs/BTabs";
import Vue from "vue";

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
var items = [];


export default {
  name: 'Login',
  components: {
    BTabs,
    Treeselect,

  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      collapse: false,
      edit_name: '',
      validate_errors: [],
      route_name: '',
      route_code: '',
      person_name: '',
      person_mobile: '',
      car_pelak: '',
      car_type: 0,
      car_name: 0,
      car_title: '',
      mizan_bar: '',
      car_volume: '',
      item_row_name: 'row',
      file: '',
      color: '#ffffff',
      previewImage: '',
      description: '',
      car_items: [],
      route_items: [],
      route_sub_items: [],
      route_sub_items_temporary: [{province:'',city:'',district:'',area:''}],
      driver_items: [],
      fields_driver: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:10%'},
        {key: 'user', label: this.$t('tables.user'), _style: 'width:10%'},
        {key: 'vehicle', label: this.$t('tables.vehicle'), _style: 'width:10%'},
        {key: 'routeTitle', label: this.$t('route'), _style: 'width:10%'},

        // {key: 'weight', label: this.$t('tables.weight'), _style: 'width:10%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},


      ],
      fields_machine: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
        {key: 'name', label: this.$t('vehicleName'), _style: 'width:20%'},
        {key: 'vehicle', label: this.$t('vehicleModel'), _style: 'width:10%'},
        {key: 'pelak', label: this.$t('tables.tag'), _style: 'width:10%'},

        {key: 'weight', label: this.$t('components.maximumWeight'), _style: 'width:10%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:5%;'},
      ],
      fields_routes: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
        {key: 'title', label: this.$t('tables.name'), _style: 'width:20%'},
        {key: 'code', label: this.$t('tables.code'), _style: 'width:10%'},
        // {key: 'weight', label: this.$t('tables.weight'), _style: 'width:10%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:10%;'},
      ],
      fields_sub_routes: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
        {key: 'provinceName', label: this.$t('Region'), _style: 'width:10%'},
        {key: 'cityName', label: this.$t('Town'), _style: 'width:10%'},
        {key: 'regionName', label: this.$t('components.district'), _style: 'width:10%'},
        {key: 'areaName', label: this.$t('tables.area'), _style: 'width:10%'},
        // {key: 'weight', label: this.$t('tables.weight'), _style: 'width:10%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],

      fields_sub_routes_temporary: [
        // {key: 'row', label: this.$t('tables.row'), _style: 'width:5%'},
        {key: 'province', label: this.$t('Region'), _style: 'width:10%'},
        {key: 'city', label: this.$t('Town'), _style: 'width:10%'},
        {key: 'district', label: this.$t('components.district'), _style: 'width:10%'},
        {key: 'area', label: this.$t('tables.area'), _style: 'width:10%'},
        // {key: 'weight', label: this.$t('tables.weight'), _style: 'width:10%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],

      car_type_items: [],

      car_name_items: [],

      selected_driver_car:0,
      driver_car_items: [],
      selected_driver_route:0,
      driver_route_items: [],

      document_person: null,

      area_items: [],
      selected_area: 0,

      province_items: [],
      selected_province: 0,

      city_items: [],
      selected_city: 0,

      district_items: [],
      selected_district: 0,

      details: [],
      collapseDuration: 0,
      // status_form: 0,
      status_form_car: 0,
      status_form_route: 0,
      status_form_driver: 0,
      table_clicks: 0,
      table_clicks_timer: null,
      inline_status_form: 0,
      load_persons({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
        }
      },
      static_user_names:[],
      static_user_state:true,
    }
  },
  created() {
  },
  mounted() {
    this.$root.root_validate_errors = [];
    this.get_car_names();
    this.get_car_types();

    this.get_car_lists();
    this.get_route_lists();
    this.get_driver_lists();
    // this.get_lists();
    this.get_provinces();
    bus.$on('delete_car_confirm', (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_car_item();

      } else {
        this.status_form_car = 0;
      }
    });
    bus.$on('delete_route_confirm', (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_route_item();

      } else {
        this.status_form_route = 0;
      }
    });
    bus.$on('delete_driver_confirm', (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_driver_item();

      } else {
        this.status_form_driver = 0;
      }
    });
  },
  watch: {
    'document_person': function () {
      // this.get_user_data();
    },
    'selected_province': function () {
      this.get_cities();
    },
    'selected_city': function () {
      this.get_districts();
    },
    'selected_district': function () {
      this.get_areas();
    }
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item_car(item)
        this.table_clicks = 0
      }

    },
    inline_item_add() {
      var item = [];
      item.provinceName = this.province_items.find(x => x.value === this.selected_province).label;
      item.province = this.selected_province;

      item.cityName = this.city_items.find(x => x.value === this.selected_city).label;
      item.city = this.selected_city;

      item.districtName = this.district_items.find(x => x.value === this.selected_district).label;
      item.district = this.selected_district;

      item.areaName = this.area_items.find(x => x.value === this.selected_area).label;
      item.area = this.selected_area;


      // this.items[0].selected_unit = 0;


      if(this.inline_status_form==0){
        this.route_sub_items_temporary.push(item);

      }else{
        Vue.set(this.route_sub_items_temporary, this.inline_status_form, item)
        this.inline_status_form =0;
      }
    },
    inline_item_edit(item,index) {
      // var item = [];
// this.items[0] = item;
      console.log("edit item");
      this.selected_province = item.province;
      this.selected_city = item.city;
      this.selected_district = item.district;
      this.selected_area = item.area;
      // Vue.set(this.route_sub_items_temporary, 0, item)
      this.inline_status_form = index;
    },
    inline_item_delete(index) {
      this.route_sub_items_temporary.splice(index, 1);
    },
    table_route_clicked(item, index) {
      this.route_sub_items = item.details.map((item, row_id) => {
        return {...item, row_id}
      });
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.document_person != '' && this.car_type != 0 && this.car_name != 0 && this.car_pelak != ''
          && this.mizan_bar != '') {
        return true;
      }


      if (this.document_person == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }
      if (this.car_type == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectVehicleType'));
      }
      if (this.car_name == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectVehicle'));
      }
      if (this.car_pelak == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertLicensePlate'));
      }
      if (this.mizan_bar == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertMaximumWeight'));
      }

      return false;
      // e.preventDefault();
    },
    validateCarForm: function () {
      this.$root.root_validate_errors = [];

      if (this.document_person != '' && this.car_type != 0 && this.car_name != 0 && this.car_pelak != ''
          && this.mizan_bar != '') {
        return true;
      }


      if (this.document_person == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }
      if (this.car_type == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectVehicleType'));
      }
      if (this.car_name == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectVehicle'));
      }
      if (this.car_pelak == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertLicensePlate'));
      }
      if (this.mizan_bar == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertMaximumWeight'));
      }

      return false;
      // e.preventDefault();
    },

    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    edit_item_car(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      // {"data":[{,"weight":1200022.00,"volume":300022.00,"id":1,"carTitle":"پراید 131","carType":"سواری"}],"isSuccess":true,"statusCode":0,"message":"عملیات با موفقیت انجام شد"}
      this.car_title = item.name;
      this.edit_name = item.name;
      this.car_pelak = item.pelak;
      this.car_name=item.carId;
      this.car_type=item.carTypeId;
      this.mizan_bar = item.weight
      this.car_volume = item.volume
      this.status_form_car = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    empty_list() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      // {"data":[{,"weight":1200022.00,"volume":300022.00,"id":1,"carTitle":"پراید 131","carType":"سواری"}],"isSuccess":true,"statusCode":0,"message":"عملیات با موفقیت انجام شد"}
      this.car_title = "";
      this.edit_name = "";
      this.car_pelak = "";
      this.mizan_bar = "";
      this.car_volume = "";
      this.status_form_car = 0;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    edit_item_driver(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      // {"data":[{,"weight":1200022.00,"volume":300022.00,"id":1,"carTitle":"پراید 131","carType":"سواری"}],"isSuccess":true,"statusCode":0,"message":"عملیات با موفقیت انجام شد"}
      this.document_person = item.personId
      this.selected_driver_car = item.carId
      this.selected_driver_route = item.routeId
      this.static_user_names=[{userId:item.personId,userName:item.personName}]
      this.static_user_state= false

      this.table_clicks_timer = setTimeout(() => {
        this.static_user_state= true

      }, 500);

      this.status_form_driver = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },

    get_route_lists() {
      var self = this;

      const formData = new FormData();

      axios.post('GetRoutesNew', formData, {
        params: {
          // isparent : self.$route.params.cat_id
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.route_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.driver_route_items = self.sort_array(
              self.driver_route_items, content_data.data,
              'id','title');

          self.selected_driver_route = self.driver_route_items[0].value;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_car_lists() {
      var self = this;

      const formData = new FormData();

      axios.post('car/GetData', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.car_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          content_data.data.forEach((val) => {
            var obj = {label: val.name, value: val.id}
            self.driver_car_items.push(obj);
          });
          self.selected_driver_car = self.driver_car_items[0].value;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_car_types() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetCarTypes', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.car_type_items = [];

          content_data.data.forEach((val) => {
            var obj = {label: val.typeTitle, value: val.id}

            self.car_type_items.push(obj);
          });
          self.car_type = self.car_type_items[0].value
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_car_names() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetCarNames', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.car_name_items = [];
          self.car_name_items = self.sort_array(
              self.car_name_items, content_data.data,
              'id','title');


          self.car_name = self.car_name_items[0].value

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goSubCategories(item) {

      this.$router.push({path: '/dashboard/delivery/driver-documents/' + item.personId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    goReturnDocuments(item) {

      this.$router.push({path: '/dashboard/delivery/driver-return-documents/' + item.personId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },

    get_user_data() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.document_person);


      axios.post('GetPersonById', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.person_mobile = content_data.data.mobileNo;
          self.person_name = content_data.data.personName;
          // self.province_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    insert_driver_data() {
      // GetDistributorUsers
      // AddDistributorUser
      // EditDistributorUser
      // DeleteDistributorUser

      // if (!this.validateForm()) {
      //   console.log("validate form is false" + this.validate_errors);
      //   return true;
      // }
      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form_driver == 0) {
        url = "AddDistributorUser";
      } else {
        url = "EditDistributorUser";
        formData.append('Id', this.status_form_driver)

      }

// Id
      // PersonId
      // PersonName =>برای ادد وادیت کلا اینو نفرس
      // CarName =>برای ادد وادیت کلا اینو نفرس
      // CarId
      // RouteTitle  =>برای ادد وادیت کلا اینو نفرس
      // RouteId
      formData.append('PersonId', this.document_person);
      formData.append('CarId', this.selected_driver_car);
      formData.append('RouteId', this.selected_driver_route);

      axios.post(url, formData, {}).then((res) => {
        self.status_form_driver = 0;
        self.name = '';
        self.color = '';
        self.description = '';
        self.previewImage = '';
        self.get_driver_lists();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_driver_lists() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetDistributorUsers', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.driver_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    insert_machine_data() {

      if (!this.validateCarForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form_car == 0) {
        url = "car/Add";
      } else {
        url = "car/Update";
        formData.append('Id', this.status_form_car)

      }

      formData.append('Volume', this.car_volume);
      formData.append('Pelak', this.car_pelak);
      formData.append('CarTypeId', this.car_type);
      formData.append('CarId', this.car_name);
      formData.append('Name', this.car_title);
      formData.append('Weight', this.mizan_bar);
      axios.post(url, formData, {}).then((res) => {
        //

        // self.status_form_car = 0;
        // self.name = '';
        // self.color = '';
        // self.description = '';
        // self.previewImage = '';
        self.get_car_lists();
if(res.data.statusCode ==0){
    self.empty_list()
}
        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_car_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.user]), [this.$t("dialogs.ok")], 'delete_car_confirm');
      this.status_form_car = item.id;
    },
    delete_route_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.user]), [this.$t("dialogs.ok")], 'delete_route_confirm');
      this.status_form_route = item.id;
    },
    delete_driver_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.user]), [this.$t("dialogs.ok")], 'delete_driver_confirm');
      this.status_form_driver = item.id;
    },
    delete_car_item() {
      let self = this;
      const formData = new FormData()
      let url;
      url = "car/Delete";
      formData.append('id', this.status_form_car);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        self.status_form_car = 0;
        self.get_car_lists();
      }).catch(function (error) {
        console.log(error);
      });
    },
    delete_route_item() {
      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteRouteNew";
      formData.append('id', this.status_form_route);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        self.status_form_route = 0;
        self.get_route_lists();
      }).catch(function (error) {
        console.log(error);
      });
    },
    delete_driver_item() {
      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteDistributorUser";
      formData.append('id', this.status_form_driver);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        self.status_form_driver = 0;
        self.get_driver_lists();
      }).catch(function (error) {
        console.log(error);
      });
    },
    insert_route_data() {

      // if (!this.validateCarForm()) {
      //   console.log("validate form is false" + this.validate_errors);
      //   return true;
      // }
      let self = this;
      const formData = new FormData();
      let url;
      // GetRoutesNew
      // AddRouteNew
      // EditRouteNew
      // DeleteRouteNew
      // Id
      // Title
      // Code
      // Details => لیست جزئیات هر مسیر در متد گت نمایش داده میشه
      // Items =>جزئیات هر مسیر که شامل همان استان وشهر و ... هستش را بصورت جیسان در قالب آیتم ارسال کن



      if (this.status_form_route == 0) {
        url = "AddRouteNew";
      } else {
        url = "EditRouteNew";
        formData.append('Id', this.status_form_route)

      }

      formData.append('Title', this.route_name);
      formData.append('Code', this.route_code);
      var items_route = [];
      this.route_sub_items_temporary.forEach((val) => {

        var obj = {provinceId: val.province, cityId: val.city,
          regionId:val.district,areaId:val.area,routeCode:''
        }
        if(obj.cityId!= ""){
          items_route.push(obj);

        }
      });
      formData.append('Items',JSON.stringify(items_route));

      axios.post(url, formData, {}).then((res) => {

        self.status_form_route = 0;
        self.route_name = '';
        self.route_code = '';
        self.route_sub_items_temporary = [{}];
        // self.description = '';
        // self.previewImage = '';
        self.get_route_lists();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },


    get_provinces() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_province);


      axios.post('GetStateList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
            self.province_items = [];

            self.province_items = self.sort_array(
              self.province_items, content_data.data,
              'id','provinceName');


          self.selected_province = self.province_items[0].value;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_cities() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_province);

      axios.post('GetCityListByStateId', formData, {show_pros:true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.city_items = []
          self.city_items = self.sort_array(
              self.city_items, content_data.data,
              'cityId','cityName');

          self.selected_city = self.city_items[0].value;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_districts() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_city);

      axios.post('GetRegionByCityId', formData, {show_pros:true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.district_items = []
          self.district_items = self.sort_array(
              self.district_items, content_data.data,
              'id','title');

          self.selected_district = self.district_items[0].value;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_areas() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_district);

      axios.post('GetAreaTitlesByCityId', formData, {show_pros:true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.area_items = []
          self.area_items = self.sort_array(
              self.area_items, content_data.data,
              'id','areaName');

          // content_data.data.forEach((val) => {
          //   var obj = {label: val.areaName, value: val.id}
          //
          //   self.area_items.push(obj);
          // });
          self.selected_area = self.area_items[0].value;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

  }
}

</script>
